import { Manager } from 'actions/actionTypes';

export const changeUpdatePopupClose = (isPopup) => ({ type: Manager.CHANGE_UPDATE_POPUP_CLOSE, payload: isPopup });
export const ChangeUpdateClientStatusSound = (isSound) => ({ type: Manager.CHANGE_UPDATE_CLIENTSTATUS_SOUND, payload: isSound });
export const ChangeUpdateClientStatusType = (isType) => ({ type: Manager.CHANGE_UPDATE_CLIENTSTATUS_TYPE, payload: isType });

export const signInSuccess = (responseData) => ({ type: Manager.SIGN_IN_SUCCESS, payload: responseData });
export const signInFailure = (errorMessage) => ({ type: Manager.SIGN_IN_FAILURE, payload: errorMessage });
export const signInReset = () => ({ type: Manager.SIGN_IN_RESET });

export const signOut = () => ({ type: Manager.SIGN_OUT });

export const tokenRefreshRequest = () => ({ type: Manager.TOKEN_REFRESH_REQUEST });;
export const tokenRefreshSuccess = (responseData) => ({ type: Manager.TOKEN_REFRESH_SUCCESS, payload: responseData });
export const tokenRefreshFailure = (errorMessage) => ({ type: Manager.TOKEN_REFRESH_FAILURE, payload: errorMessage });

// 공지사항 팝업 조회
export const loadNoticePopupRequest = () => ({ type: Manager.LOAD_NOTICE_POPUP_REQUEST });
export const loadNoticePopupRequestSuccess = (responseData) => ({ type: Manager.LOAD_NOTICE_POPUP_REQUEST_SUCCESS, payload: responseData });
export const loadNoticePopupRequestFailure = (errorMessage) => ({ type: Manager.LOAD_NOTICE_POPUP_REQUEST_FAILURE, payload: errorMessage });